import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { authFail, resetAuthError, logOut } from 'store/actions'
import { Formik, Form, Field } from 'formik'
import AuthErrorBox from 'components/Auth/AuthErrorBox'
import Logo from 'components/Logo/Logo'
import LoadingButton from 'components/ui/LoadingButton/LoadingButton'
import { accountsApi } from '../../api'
import * as Yup from 'yup'
import { t } from 'translation'

const logoutSchema = Yup.object().shape({
  code: Yup.string().required('LOGOUT_CODE_IS_REQUIRED'),
})

class LogoutModal extends Component {
  state = { isLoading: false, success: false }

  closeModalHandler = () => {
    if (this.state.isLoading) return

    this.props.resetAuthError()
    this.setState({ success: false, isLoading: false })
    this.props.closeLogoutHandler()
  }

  render() {
    const secret = 'VBYFOBTU'

    return (
      <div className="popup alarm_mod" onClick={(e) => e.stopPropagation()}>
        <button
          className="close_btn right_pos_mod alarm_mod"
          onClick={this.props.closeLogoutHandler}
        ></button>
        <div className="section logout_mod offset_v2_mod session_type_mod">
          <div className="section_in center_content_mod">
            <div className="section_heading offset_mod">
              <h2 className="section_title center_mod title_step_center_mod email_pain_mod">
                {t('auth.LOGOUT_HEADER')}
              </h2>
            </div>
            <div className="session_type_descr logout_text">
              <p>{t('auth.LOGOUT_DESCR')}</p>
            </div>
            <Formik
              initialValues={{ code: '' }}
              validationSchema={logoutSchema}
              onSubmit={async ({ code }) => {
                this.props.resetAuthError()

                if (code !== secret) return this.props.authFail('WRONG_LOGOUT_CODE')

                this.setState({ isLoading: true })

                const { error } = await accountsApi.logoutUser()

                this.setState({ isLoading: false })

                if (error) return this.props.authFail(error)

                this.setState({ success: true })

                this.props.logOut()
              }}
            >
              {({ errors, touched, submitForm, status, setStatus, isValid }) => (
                <Form style={{ width: '100%' }}>
                  <div className="">
                    {!this.state.success && (
                      <div className="email_invite_form_item message_box">
                        <AuthErrorBox
                          formFields={['code']}
                          formTouched={touched}
                          formErrors={errors}
                          apiResponseError={this.props.authError || ''}
                          resetApiResponseError={this.props.resetAuthError}
                          clickedSubmit={status === 'clicked'}
                          className="email_invite"
                        />
                      </div>
                    )}
                    {this.state.success && isValid ? (
                      <div className="email_invite_form_item message_box">
                        <div className="success_text form_success email_invite">
                          {t('auth.LOGOUT_SUCCESSFUL')}
                        </div>
                      </div>
                    ) : null}
                    <div className="email_invite_form_item input_field">
                      <Field
                        className={`form_field v4_mod email_invite_mod ${
                          status === 'clicked' && errors.email ? 'error' : ''
                        }`}
                        type="password"
                        name="code"
                        placeholder={t('auth.ENTER_CODE')}
                        disabled={this.state.isLoading || this.state.success}
                      />
                    </div>
                    <div className="email_invite_form_item submit_btn">
                      <LoadingButton
                        noBtnBase
                        disabled={this.state.success}
                        isLoading={this.state.isLoading}
                        className="session_type_item_btn email_invite_mod"
                        onClick={() => {
                          setStatus('clicked')
                          submitForm()
                        }}
                      >
                        {t('auth.LOGOUT_SEND')}
                      </LoadingButton>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ auth: { error } }) => ({
  authError: error,
})

const willMapDispatchToProps = {
  authFail,
  resetAuthError,
  logOut,
}

export default connect(mapStateToProps, willMapDispatchToProps)(LogoutModal)

LogoutModal.propTypes = {
  authFail: PropTypes.func.isRequired,
  resetAuthError: PropTypes.func.isRequired,
  closeLogoutHandler: PropTypes.func.isRequired,
}
